/** The id of the Team section on a project's page, so a link can land on it. */
export const PROJECT_TEAM_SECTION_ID = 'team';

export const APP_ROUTES = {
  login: '/login',
  dashboard: '/',
  clients: {
    list: '/clients',
    create: '/clients/new',
    detail: (id = ':clientId') => `/clients/${id}`,
    edit: (id = ':clientId') => `/clients/${id}/edit`,
  },
  projects: {
    list: '/projects',
    create: '/projects/new',
    detail: (id = ':projectId') => `/projects/${id}`,
    team: (id = ':projectId') => `/projects/${id}#${PROJECT_TEAM_SECTION_ID}`,
    edit: (id = ':projectId') => `/projects/${id}/edit`,
    board: (id = ':projectId') => `/projects/${id}/board`,
  },
  allocations: {
    list: '/allocations',
    create: '/allocations/new',
  },
  resources: {
    detail: (userId = ':userId') => `/resources/${userId}`,
  },
  approvals: '/approvals',
  utilisation: {
    list: '/utilisation',
    department: (department = ':department') => `/utilisation/departments/${department}`,
  },
  admin: {
    resourceRoles: '/admin/resource-roles',
  },
} as const;
